/*
 * @Descripttion: 
 * @version: 
 * @Author: 付正生
 * @Date: 2022-04-19 20:30:27
 * @LastEditors: James chen
 * @LastEditTime: 2022-07-01 10:39:14
 */

// 移动端比PC端多出的页面
export const appNewRoute = [
  {
    path: '/qualityManagement/handlingUnqualified',
    name: 'handlingUnqualified',
    component: () => import('@/views/qualityManagement/defectsPending/handlingUnqualified'),
    meta: { title: '不合格品处理', keepAlive: false }
  },
  {
    path: '/qualityManagement/handlingUnqualifieds',
    name: 'handlingUnqualifieds',
    component: () => import('@/views/qualityManagement/defectsPending/handlingUnqualifieds'),
    meta: { title: '批量处理', keepAlive: false }
  },
  {
    path: '/stockManagementDetail',
    name: 'stockManagementDetail',
    component: () => import('@/views/warehouseManagement/stockManagement/stockManagementDetail'),
    meta: { title: '库存详情', keepAlive: false }
  },
  {
    path: '/stockManagementForm',
    name: 'stockManagementForm',
    component: () => import('@/views/warehouseManagement/stockManagement/stockManagementForm'),
    meta: { title: '水位管理', keepAlive: false }
  },
  {
    path: '/qualityTask/report',
    name: 'qualityTaskReport',
    component: () => import('@/views/qualityManagement/qualityTask/report'),
    meta: { title: '质检报工', keepAlive: false }
  },
  {
    path: '/maintenanceReturn',
    name: 'maintenanceReturn',
    component: () => import('@/views/baseManagement/maintain/myRepair/maintenanceReturn'),
    meta: { title: '退回', keepAlive: false }
  },
  {
    path: '/commonSettings',
    name: 'commonSettings',
    component: () => import('@/views/dashboard/commonSettings'),
    meta: { title: '常用设置', keepAlive: false, mgt: true }
  },
  {
    path: '/submitPurchaseTask',
    name: 'submitPurchaseTask',
    component: () => import('@/views/planManage/workshopDemand/form'),
    meta: { title: '提交采购任务', keepAlive: false }
  },
  {
    path: '/submitPurchaseTask',
    name: 'submitPurchaseTask',
    component: () => import('@/views/planManage/workshopDemand/form'),
    meta: { title: '提交采购任务', keepAlive: false }
  },
  {
    path: '/requirementDetails',
    name: 'requirementDetails',
    component: () => import('@/views/planManage/workshopDemand/detailList'),
    meta: { title: '需求明细', keepAlive: false }
  },
  {
    path: '/buildRecord',
    name: 'buildRecord',
    component: () => import('@/views/workManagement/reportRecord/buildRecord'),
    meta: { title: '生产报工', keepAlive: false }
  },
  {
    path: '/buildQuality',
    name: 'buildQuality',
    component: () => import('@/views/qualityManagement/qualityRecord/buildQuality'),
    meta: { title: '质检报工', keepAlive: false }
  },
  {
    path: '/batchReport',
    name: 'batchReport',
    component: () => import('@/views/productionBatch/batchReport'),
    meta: { title: '批次报工', keepAlive: false }
  },
  {
    path: '/manHourCalculation',
    name: 'manHourCalculation',
    component: () => import('@/views/workManagement/productionPlanning/manHourCalculation'),
    meta: { title: '工时测算', keepAlive: false }
  },
  {
    path: '/selectItems',
    name: 'selectItems',
    component: () => import('@/views/workManagement/productionPlanning/selectItems'),
    meta: { title: '选择物品', keepAlive: false }
  },
]
